(function () {
  var STORAGE_KEY = 'attire_wishlist_v1';
  var REMINDER_DAYS = 2;

  function read() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('attire:wishlist:change', { detail: { items: items } }));
  }

  function keyOf(item) {
    return String(item.variantId || item.productId);
  }

  function has(items, productId, variantId) {
    var id = String(variantId || productId);
    return items.some(function (item) {
      return keyOf(item) === id || String(item.productId) === String(productId);
    });
  }

  function klaviyoTrack(eventName, payload) {
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['track', eventName, payload]);
        return;
      }
      window._learnq = window._learnq || [];
      window._learnq.push(['track', eventName, payload]);
    } catch (e) {}
  }

  function klaviyoIdentify(email) {
    if (!email) return;
    try {
      if (window.klaviyo && typeof window.klaviyo.push === 'function') {
        window.klaviyo.push(['identify', { email: email }]);
        return;
      }
      window._learnq = window._learnq || [];
      window._learnq.push(['identify', { $email: email }]);
    } catch (e) {}
  }

  function customerEmail() {
    return (window.theme && window.theme.customerEmail) || '';
  }

  function upsertItem(data) {
    var items = read();
    var id = keyOf(data);
    var exists = items.some(function (item) { return keyOf(item) === id; });
    if (exists) {
      items = items.filter(function (item) { return keyOf(item) !== id; });
      write(items);
      klaviyoTrack('Removed from Wishlist', {
        ProductID: data.productId,
        ProductName: data.title,
        VariantID: data.variantId,
        URL: data.url
      });
      return { added: false, items: items };
    }

    var entry = {
      productId: String(data.productId),
      variantId: String(data.variantId || ''),
      handle: data.handle || '',
      title: data.title || '',
      price: data.price || '',
      image: data.image || '',
      url: data.url || '',
      addedAt: Date.now()
    };
    items.unshift(entry);
    write(items);

    klaviyoIdentify(customerEmail());
    klaviyoTrack('Added to Wishlist', {
      ProductID: entry.productId,
      ProductName: entry.title,
      VariantID: entry.variantId,
      ImageURL: entry.image,
      URL: entry.url,
      Price: entry.price,
      WishlistURL: window.location.origin + '/pages/wishlist',
      ReminderDelayDays: REMINDER_DAYS
    });

    return { added: true, items: items };
  }

  function syncButtons() {
    var items = read();
    document.querySelectorAll('[data-attire-wishlist-toggle]').forEach(function (btn) {
      var active = has(items, btn.getAttribute('data-product-id'), btn.getAttribute('data-variant-id'));
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    });
  }

  function money(price) {
    if (!price) return '';
    if (String(price).indexOf('€') !== -1 || String(price).indexOf('$') !== -1) return String(price);
    return '€' + String(price);
  }

  function placeButtonByTitle() {
    var header = document.querySelector('.product-block--header');
    var btn = document.querySelector('[data-attire-wishlist-toggle]');
    if (!header || !btn || header.contains(btn)) return;
    var title = header.querySelector('.product-single__title');
    if (!title) return;
    var row = document.createElement('div');
    row.className = 'product-single__title-row';
    title.parentNode.insertBefore(row, title);
    row.appendChild(title);
    row.appendChild(btn);
    var orphan = btn.closest('.product-block');
    if (orphan && orphan !== header && !orphan.querySelector('[data-attire-wishlist-toggle]') && orphan.textContent.trim() === '') {
      orphan.remove();
    }
  }

  function renderPage() {
    var root = document.querySelector('[data-attire-wishlist-page]');
    if (!root) return;
    var empty = root.querySelector('[data-attire-wishlist-empty]');
    var grid = root.querySelector('[data-attire-wishlist-grid]');
    var items = read();

    if (!items.length) {
      if (empty) empty.hidden = false;
      if (grid) {
        grid.hidden = true;
        grid.innerHTML = '';
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (!grid) return;
    grid.hidden = false;
    grid.innerHTML = items.map(function (item) {
      var href = item.url || ('/products/' + item.handle);
      var img = item.image || '';
      if (img.indexOf('//') === 0) img = 'https:' + img;
      return (
        '<article class="attire-wishlist-card" data-product-id="' + item.productId + '" data-variant-id="' + item.variantId + '">' +
          '<button type="button" class="attire-wishlist-card__remove" data-attire-wishlist-remove aria-label="Remove">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 6l12 12M18 6L6 18"/></svg>' +
          '</button>' +
          '<a class="attire-wishlist-card__media" href="' + href + '">' +
            (img ? '<img src="' + img + '" alt="' + (item.title || '') + '">' : '') +
          '</a>' +
          '<h3 class="attire-wishlist-card__title"><a href="' + href + '">' + (item.title || '') + '</a></h3>' +
          '<p class="attire-wishlist-card__price">' + money(item.price) + '</p>' +
          '<div class="attire-wishlist-card__actions"><a class="btn btn--secondary" href="' + href + '">View</a></div>' +
        '</article>'
      );
    }).join('');
  }

  function onToggle(btn) {
    var result = upsertItem({
      productId: btn.getAttribute('data-product-id'),
      variantId: btn.getAttribute('data-variant-id'),
      handle: btn.getAttribute('data-handle'),
      title: btn.getAttribute('data-title'),
      price: btn.getAttribute('data-price'),
      image: btn.getAttribute('data-image'),
      url: btn.getAttribute('data-url')
    });
    syncButtons();
    renderPage();
    return result;
  }

  document.addEventListener('click', function (event) {
    var toggle = event.target.closest('[data-attire-wishlist-toggle]');
    if (toggle) {
      event.preventDefault();
      onToggle(toggle);
      return;
    }
    var remove = event.target.closest('[data-attire-wishlist-remove]');
    if (remove) {
      event.preventDefault();
      var card = remove.closest('.attire-wishlist-card');
      if (!card) return;
      upsertItem({
        productId: card.getAttribute('data-product-id'),
        variantId: card.getAttribute('data-variant-id'),
        title: '',
        url: ''
      });
      syncButtons();
      renderPage();
    }
  });

  document.addEventListener('attire:wishlist:change', function () {
    syncButtons();
    renderPage();
  });

  document.addEventListener('DOMContentLoaded', function () {
    placeButtonByTitle();
    klaviyoIdentify(customerEmail());
    syncButtons();
    renderPage();
  });

  window.AttireWishlist = { read: read, write: write, toggle: onToggle };
})();
